<template>
  <div>

    <v-row>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>MRR</v-card-title>
          <v-card-text class="text-h4 text--primary">
            <span v-if="mrr !== null">R$ {{ mrr | formatMoney }}</span>
            <span v-else>—</span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Ticket médio (geral)</v-card-title>
          <v-card-text class="text-h4 text--primary">
            <span v-if="ticket_avg !== null">R$ {{ ticket_avg | formatMoney }}</span>
            <span v-else>—</span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Ticket médio (pagantes)</v-card-title>
          <v-card-text class="text-h4 text--primary">
            <span v-if="ticket_avg_pay !== null">R$ {{ ticket_avg_pay | formatMoney }}</span>
            <span v-else>—</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5">
        <v-card>
          <v-card-title>Clientes por status</v-card-title>
          <v-card-text>
            <bar-chart v-if="data_status" :chart-data="data_status" :options="chart_options" :styles="chart_styles"/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title>Clientes por cidade</v-card-title>
          <v-card-text>
            <bar-chart v-if="data_city" :chart-data="data_city" :options="chart_options" :styles="chart_styles"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Clientes por plano</v-card-title>
          <v-card-text>
            <bar-chart v-if="data_plan" :chart-data="data_plan" :options="chart_options" :styles="chart_styles"/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from '../../api/index.js';
import BarChart from '../../components/BarChart.js';

const STATUS_LABELS = ["Habilitado", "Bloq. administrador", "Bloq. cliente", "Bloq. pagamento", "Cancelado"];
const STATUS_COLORS = ["#4CAF50", "#FB8C00", "#2196F3", "#FF5252", "#9E9E9E"];

export default {
  components: { BarChart },
  data: () => ({
    data_city: null,
    data_status: null,
    data_plan: null,
    ticket_avg: null,
    ticket_avg_pay: null,
    mrr: null,
    pending: 0,
    dialog_loading: false,
    chart_options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }]
      }
    },
    chart_styles: {
      position: "relative",
      height: "320px",
      width: "100%"
    }
  }),
  created: function() {
    this.loadCity();
    this.loadStatus();
    this.loadPlan();
    this.loadTicket();
    this.loadTicketPay();
    this.loadMrr();
  },
  methods: {
    headers: function(){
      return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } };
    },
    begin: function(){
      this.pending++;
      this.dialog_loading = true;
    },
    done: function(){
      this.pending--;
      if(this.pending<=0){
        this.dialog_loading = false;
      }
    },
    loadCity: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/city", me.headers())
      .then(function(response){
        me.done();
        me.data_city = {
          labels: response.data.map(function(r){ return r[0]; }),
          datasets: [{
            label: "Clientes",
            backgroundColor: "#1976D2",
            data: response.data.map(function(r){ return r[1]; })
          }]
        };
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar relatório por cidade!");
      });
    },
    loadStatus: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/status", me.headers())
      .then(function(response){
        me.done();
        me.data_status = {
          labels: response.data.map(function(r){ return STATUS_LABELS[r[0]] || "Desconhecido"; }),
          datasets: [{
            label: "Clientes",
            backgroundColor: response.data.map(function(r){ return STATUS_COLORS[r[0]] || "#607D8B"; }),
            data: response.data.map(function(r){ return r[1]; })
          }]
        };
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar relatório por status!");
      });
    },
    loadTicket: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/ticket/all", me.headers())
      .then(function(response){
        me.done();
        me.ticket_avg = response.data;
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar ticket médio!");
      });
    },
    loadTicketPay: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/ticket/pay", me.headers())
      .then(function(response){
        me.done();
        me.ticket_avg_pay = response.data;
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar ticket médio de pagantes!");
      });
    },
    loadMrr: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/ticket/mrr", me.headers())
      .then(function(response){
        me.done();
        me.mrr = response.data;
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar MRR!");
      });
    },
    loadPlan: function(){
      var me = this;
      me.begin();
      api.get("/lastmile/report/plan", me.headers())
      .then(function(response){
        me.done();
        me.data_plan = {
          labels: response.data.map(function(r){ return r[0]; }),
          datasets: [{
            label: "Clientes",
            backgroundColor: "#FB8C00",
            data: response.data.map(function(r){ return r[1]; })
          }]
        };
      })
      .catch(function(error){
        me.done();
        console.log(error);
        alert("Falha ao carregar relatório por plano!");
      });
    }
  }
};
</script>
